import React, { useCallback, useEffect, useState } from 'react';

interface IPandaPlayerProviderProps {
  video: string;
  style?: React.CSSProperties;
  onEnded?: (ref: any | null) => void;
}

const PandaPlayerProvider: React.FC<IPandaPlayerProviderProps> = ({
  video,
  style,
  onEnded,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const [isEnded, setIsEnded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.pandavideo.com.br/api.v2.js';
    script.async = true;

    document.body.appendChild(script);

    console.log('script', script);

    return () => {
      document.body.removeChild(script);
    };

  }, []);

  const onEndedEvent = useCallback((player: any, eventName: string,) => {
    console.log('EVENT', eventName);
    console.log('isEnded', isEnded);

    if (isEnded) return;

    if (eventName === 'panda_ended') {
      setIsEnded(true);
      console.log('ENDED');
      onEnded && onEnded(player);
    }
  }, [onEnded, isEnded]);

  useEffect(() => {
    if (isLoaded) return;

    console.log('esta executando');

    // @ts-ignore
    window.pandascripttag = window.pandascripttag || [];
    // @ts-ignore
    window.pandascripttag.push(function () {
      // @ts-ignore
      const player = new PandaPlayer(`panda-${video}`, {
        onReady: () => {
          console.log('PLAYER LOADED')
          setIsLoaded(() => true);

          player.onEvent((event: any) => {
            onEndedEvent(player, event.message);
          });	
        },
        onEnded: () => {
          console.log('ENDED7777777777777777777');
        }
      });
    });
  }, [video, onEndedEvent, isLoaded]);

  return (
    <div
      style={{ minHeight: 'auto', position: 'relative', paddingTop: '56.25%', zIndex: 9, }}>
      <iframe
        title="video"
        id={`panda-${video}`}
        src={`https://player-vz-27884646-502.tv.pandavideo.com.br/embed/?v=${video}`}
        style={style ? style : { border: 'none', position: 'absolute', top: 0, left: 0, }}
        allowFullScreen={true}
        width="100%"
        height="100%"
      />

    </div>
  );
}

export default PandaPlayerProvider;